/**
 * Medición de la visita técnica — lo que convierte un «A verificar» del despiece
 * en un renglón derivado de un dato del sitio.
 *
 * El motor (`calcularDespiece`) ya aceptaba `distancias` y `montaje`. Lo que faltaba
 * era una vía HONESTA desde el formulario: vacío, 0 o basura NO son una medición.
 * Si se los pasara como número, el despiece afirmaría haber medido cuando nadie midió.
 */

function metro(v) {
  if (v == null || v === '') return null;
  const n = Number(String(v).replace(',', '.').trim());
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * Extrae las distancias medidas (metros) de un formulario o de un snapshot `entrada`.
 * Solo incluye las claves que el técnico realmente llenó.
 *
 * @param {object} raw  `{ distancias }` o el objeto de distancias mismo
 * @returns {{ arregloInversor?: number, inversorTablero?: number, tableroMedidor?: number }}
 */
export function distanciasDeVisita(raw) {
  if (!raw || typeof raw !== 'object') return {};
  const src = raw.distancias && typeof raw.distancias === 'object' ? raw.distancias : raw;
  const out = {};
  const a = metro(src.arregloInversor);
  const b = metro(src.inversorTablero);
  const c = metro(src.tableroMedidor);
  if (a != null) out.arregloInversor = a;
  if (b != null) out.inversorTablero = b;
  if (c != null) out.tableroMedidor = c;
  return out;
}

/**
 * Montaje declarado en la visita. Cualquier otro valor se ignora: el despiece
 * asume cubierta y lo dice.
 *
 * @returns {'techo'|'piso'|null}
 */
export function montajeDeVisita(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const m = raw.montaje || raw.distancias?.montaje || null;
  return m === 'piso' || m === 'techo' ? m : null;
}

export default { distanciasDeVisita, montajeDeVisita };
